import { Observable } from 'rxjs';
import { HdWizardStepMeta } from '../wizard-native/interface';
import { HdWizardStateMachineInterface } from '../wizard-native/state-machine';
import { HdWizardStepTracker } from '../wizard-native/step-tracker';

export function useStateMachine({
  steps = [],
  getInitialPath
}: {
  steps: HdWizardStepMeta[];
  getInitialPath: (stepTracker: HdWizardStepTracker) => string | Observable<string> | Promise<string>;
}): HdWizardStateMachineInterface {
  return {
    steps,
    queryParamKey: 'wizard_step',
    getInitialPath,
    getStepFromPath: (path: string) => {
      return steps.find(step => step.path === path);
    }
  };
}
